



















































import { Component, Prop, Model, Vue } from "vue-property-decorator";
import { ILongTrend } from "@/types/longTrend"; 
import { ExtendedVessel } from "@/types/vessel";
import store from "@/store";
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import LongTrendsModule from "@/store/clients/LongTrends.module";

const Vessels = getModule(VesselsModule, store);
const LongTrends = getModule(LongTrendsModule, store);

@Component
export default class BenchmarkSettings extends Vue {
  @Model("update:modelValue") benchmark!: number;
  @Prop() readonly longTrendName!: string;

  isBenchmarkOpen: boolean = false;
  manualBenchmarkLevel = 0;
  
  get longTrend(): ILongTrend {
    return LongTrends.vesselLongTrendByName(this.longTrendName).longTrend;
  }

  get vessel(): ExtendedVessel | null {
    if (!Vessels.currentVessel) return null;
    return Vessels.currentVessel;
  }
  
  benchmarkLevelInputRules(value: any): boolean | string {
    if (value === null || value === undefined || value === "") {
      return "Enter benchmark level";
    }

    const numericValue = Number(value);

    if (!Number.isFinite(numericValue)) {
      return "Benchmark level must be a valid number";
    }

    if (numericValue < -40 || numericValue > 40) {
      return "Benchmark level must be between -40 and 40.";
    }

    return true;
  }

  onBenchmarkChange(benchmark: string) {
    this.$emit("update:modelValue", Number(benchmark));
  }
}
